<div class="iv" [class.iv--expanded]="expanded">

  <!-- ════════════════════════════════════════════════════
       LOADING STATE — skeleton row
  ════════════════════════════════════════════════════ -->
  @if (loadingList || loadingDetail) {
    <div class="iv-row iv-row--skeleton">
      <div class="s26-skeleton s26-skeleton--btn"></div>
      <div class="s26-skeleton s26-skeleton--id"></div>
      <div class="s26-skeleton s26-skeleton--chip"></div>
      <div class="s26-skeleton s26-skeleton--dots"></div>
      <div class="s26-skeleton s26-skeleton--date"></div>
      <span class="s26-spacer"></span>
      <div class="s26-skeleton s26-skeleton--dots"></div>
    </div>
  }

  <!-- ════════════════════════════════════════════════════
       EMPTY STATE
  ════════════════════════════════════════════════════ -->
  @if (!(loadingList || loadingDetail) && !verifications.length) {
    <div class="iv-row iv-row--empty">
      <mat-icon class="iv-empty__icon">verified_user</mat-icon>
      <span class="s26-kv-val">{{'verification.id.noVerificationMessage' | translate}}</span>
      <button mat-stroked-button color="primary" class="iv-start-btn" (click)="startVerification()">
        {{'verification.id.startVerificationMessage' | translate}}
      </button>
    </div>
  }

  <!-- ════════════════════════════════════════════════════
       MAIN CONTENT
  ════════════════════════════════════════════════════ -->
  @if (!(loadingList || loadingDetail) && verifications.length) {

    <!-- ── Collapsed row (always visible) ── -->
    <div class="iv-row" [class.iv-row--loading]="loadingDetail" (click)="toggleExpanded()">

      <!-- Navigation -->
      <div class="iv-nav">
        <button class="iv-nav__trigger"
                [matMenuTriggerFor]="verificationMenu"
                [disabled]="!verifications.length"
                (click)="$event.stopPropagation()"
                (menuOpened)="newVerificationIds.clear()"
                >
            @if (newVerificationIds.size > 0) {
              <div class="iv-nav__dot"></div>
            } @else {
              <mat-icon>
                arrow_drop_down
              </mat-icon>
            }
            <span class="s26-kv-val">{{ currentDetail?.startedAt | date:'dd.MM.yy HH:mm' }}</span>
        </button>

        <mat-menu #verificationMenu="matMenu" class="iv-nav-menu">
          @for (v of verifications; track v.id; let i = $index) {
            <button mat-menu-item
                    class="iv-nav-menu__item"
                    [class.iv-nav-menu__item--active]="i === currentIndex"
                    (click)="selectVerification(i)">
              <span class="iv-nav-menu__row">
                <span class="s26-kv-val">{{ v.startedAt | date:'dd.MM.yy HH:mm' }}</span>
                <span class="s26-chip s26-chip--{{ statusClass(v.status) }} s26-chip--xs">
                  {{'verification.id.status.' + v.status | translate}}
                </span>
              </span>
            </button>
          }
        </mat-menu>
      </div>

      <div class="s26-sep"></div>

      <!-- @if (currentDetail) {
        @if (currentIsActive) {
          <mat-menu #statusMenu="matMenu">
            <button mat-menu-item (click)="decide('complete')">
              <span>{{'verification.id.status.COMPLETED' | translate}}</span>
            </button>
            <button mat-menu-item (click)="decide('reject')">
              <span>{{'verification.id.status.FAILED' | translate}}</span>
            </button>
          </mat-menu>

          <div class="s26-chip s26-chip--{{ statusClass(currentDetail.status) }} s26-chip--actionable"
               [matMenuTriggerFor]="statusMenu"
               matTooltip="Промени статусa"
               matTooltipPosition="above"
               (click)="$event.stopPropagation()">
            {{'verification.id.status.' + currentDetail.status | translate}}
            <mat-icon>arrow_drop_down</mat-icon>
          </div>

        } @else {
          <div class="s26-chip s26-chip--{{ statusClass(currentDetail.status) }}">
            {{'verification.id.status.' + currentDetail.status | translate}}
          </div>
        }
      } @else {
        <span class="iv-id iv-id--ghost">—</span>
      } -->
      @if (currentDetail) {
        <div class="s26-chip s26-chip--{{ statusClass(currentDetail.status) }}">
          {{'verification.id.status.' + currentDetail.status | translate}}
        </div>
      } @else {
        <span class="iv-id iv-id--ghost">—</span>
      }

      <div class="s26-sep"></div>

      @if (currentDetail) {
        <span class="s26-kv-val">{{'verification.id.flow.' + currentDetail.flow | translate}}</span>
      }

      <span class="s26-spacer"></span>

      <itfg-mat-tab-menu class="iv__menu-btn" yPosition="above" (click)="toggleExpanded()">
        <div trigger><mat-icon>more_horiz</mat-icon></div>
        <div content>
          <button mat-menu-item [disabled]="active > 0" (click)="startVerification()">
            {{'verification.id.startVerificationMessage' | translate}}
          </button>
          <button mat-menu-item [disabled]="!currentIsActive" (click)="decide('complete')">
            {{'verification.id.status.COMPLETED' | translate}}
          </button>
          <button mat-menu-item [disabled]="!currentIsActive" (click)="decide('reject')">
            {{'verification.id.status.FAILED' | translate}}
          </button>
        </div>
      </itfg-mat-tab-menu>

    </div>

    <!-- ── Expandable details panel ── -->
    <div class="iv-panel" [class.iv-panel--open]="expanded">
      <div class="iv-panel__inner">

        @if (loadingDetail) {
          <div class="iv-panel__loading">
            <mat-spinner diameter="22" />
          </div>
        }

        @if (!loadingDetail && currentDetail) {

          <div class="iv-split__body">

            <!-- Left: flat event list -->
            <div class="iv-ev-list">
              @for (ev of events; track ev.id) {
                <div class="iv-ev-item"
                     [class.iv-ev-item--active]="selectedEventId === ev.id"
                     [class.iv-ev-item--clickable]="!!ev.data"
                     (click)="ev.data && toggleEvent(ev.id)">

                  <div class="iv-ev-item__dot"
                       [style.background]="
                         isFailEvent(ev.type)    ? '#e53935' :
                         isSuccessEvent(ev.type) ? '#43a047' :
                         procColor(ev.processor)">
                  </div>

                  <span class="iv-ev-item__type"
                        [class.iv-ev-item__type--fail]="isFailEvent(ev.type)"
                        [class.iv-ev-item__type--ok]="isSuccessEvent(ev.type)">
                    {{ ev.type.split('_').join(' ') }}
                  </span>

                  <span class="s26-mono">
                    {{ ev.createdAt | date:'HH:mm:ss' }}
                  </span>

                </div>
              }
            </div>

            <div class="iv-split__divider"></div>

            <!-- Right: event data OR verification details -->
            <div class="iv-detail-pane">

              @if (selectedEventId) {
                @for (ev of events; track ev.id) {
                  @if (ev.id === selectedEventId) {

                    <div class="iv-detail-pane__meta">
                      <span class="s26-field">{{ ev.createdAt | date:'dd.MM.yyyy HH:mm:ss' }}</span>
                      <span class="s26-proc-tag"
                            [style.background]="procColor(ev.processor) + '14'"
                            [style.color]="procColor(ev.processor)">
                        {{ ev.processor }}
                      </span>
                    </div>

                    @for (entry of eventDataEntries(ev); track entry[0]) {
                      <div class="iv-event-data__row">
                        <span class="iv-event-data__key">{{ entry[0] }}</span>
                        <span class="iv-event-data__val s26-mono">{{ entry[1] }}</span>
                      </div>
                    }
                    @if (!eventDataEntries(ev).length) {
                      <span class="iv-event-data__empty">No data</span>
                    }

                  }
                }
              } @else {

                <div class="s26-field"><span>id</span>       <span class="s26-mono">#{{ currentDetail.id }}</span></div>
                <div class="s26-field">
                    <span>{{'verification.id.flow.label' | translate}}</span>
                    <span class="s26-mono">{{'verification.id.flow.' +  currentDetail.flow | translate}}</span>
                </div>
                <div class="s26-field">
                  <span>{{'verification.id.startedAt' | translate}}</span>
                  <span>{{ currentDetail.startedAt | date:'dd.MM.yy HH:mm' }}</span>
                </div>
                <div class="s26-field">
                  <span>{{'verification.id.endedAt' | translate}}</span>
                  <span>{{ (currentDetail.endedAt | date:'dd.MM.yy HH:mm') ?? '—' }}</span>
                </div>
                <div class="s26-field">
                  <span>{{'verification.id.duration' | translate}}</span>
                  <span>{{ duration(currentDetail.startedAt, currentDetail.endedAt) }}</span>
                </div>
                
                @if (currentDetail.miReportId) {
                  <div class="s26-field">
                    <span>{{'verification.id.miReport' | translate}}</span> 
                    <span class="s26-mono">#{{ currentDetail.miReportId }}</span>
                  </div>
                }

              }
            </div>

          </div>
        }

      </div>
    </div>

  }

</div>